import { db } from "../config/firebase";
import { size, forEach } from "lodash";
import _actions from "../_actions";
import { store } from "../Store";

const subscriptions = {};

export const getSubscriptions = () => subscriptions;

export const createSubscription = (ref, { limit, order, where } = {}) => {
  if (subscriptions[ref]) {
    return;
  }

  if (ref === "products") {
    // where = ["productCode", "==", "test"];
    // limit = 5;
  }

  try {
    let sub = db.collection(ref);

    if (where) {
      sub = sub.where(where[0], where[1], where[2]);
    }

    if (order) {
      sub = sub.orderBy(order[0], order[1] || "asc");
    }

    if (limit) {
      sub = sub.limit(limit);
    }

    // sub = sub.limit(5);

    sub.onSnapshot((collectionData) => {
      const data = {};

      collectionData.forEach((doc) => {
        data[doc.id] = doc.data();
      });
      store.dispatch(_actions.setData({ path: ref, data }));
    });

    console.info(`Subscription created for ${ref}`);
    subscriptions[ref] = sub;
  } catch (e) {
    console.error("Subscription failed", { ref, e });
  }
};

export const batchUpdate = async ({ data, ref, method = "update" }) => {
  const batches = [];
  // let batch = db.batch();
  batches[0] = db.batch();
  const maxSize = 500;
  let count = 0;
  let totalCount = 0;
  let batchCount = 0;
  const totalEntries = size(data);

  forEach(data, (entry, docId) => {
    count = count + 1;
    totalCount = totalCount + 1;
    batches[batchCount][method](db.collection(ref).doc(docId), entry);

    if (count === maxSize || totalCount === totalEntries) {
      count = 0;
      batchCount = batchCount + 1;
      batches[batchCount] = db.batch();
      // batches.push(batch);
      // batch = db.batch();
    }
  });

  console.log({ batches, totalEntries, ref, method });
  try {
    await Promise.all(batches.map((batch) => batch.commit()));
  } catch (e) {
    console.error(e);
  }
};
